import {
  doGetQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { INSTITUICAO_FINANCIADORA_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    INSTITUICAO_FINANCIADORA_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    INSTITUICAO_FINANCIADORA_ENDPOINT,
    id
  ]);
}
